import { TFunction } from 'i18next';

import { ModalStateType } from '~/contexts/modal/ModalContext';
import { colors } from '~/theme/colors';

export const FREE_AMOUNT_OF_DAYS = 7;
export const DEFAULT_DISCOUNT_VALUE = 35;

export const nonPrepaidModalConfig: Partial<ModalStateType> = {
  isFullScreen: false,
  maxWidth: '880px',
  paddingSize: '0px',
  closeButtonColor: colors.neutral_30,
  pageViewMobile: true,
};

export const getFormParams = (
  t: TFunction,
): {
  cardExpiryDatePlaceholder: string;
  cardHolderPlaceholder: string;
  isCardHolderVisible: boolean;
} => {
  return {
    cardExpiryDatePlaceholder: 'MM/YY',
    cardHolderPlaceholder: t('general:cardholder_name', 'Cardholder Name'),
    isCardHolderVisible: true,
  };
};

export const PREPAID_PURCHASE_SOURCE = 'prepaid_promo';

export enum PrepaidBenefits {
  DISCOUNT_35 = 'discount_35',
  EXTRA_WEEK_TRIAL = 'extra_week_trial',
}

export enum PrepaidPlaces {
  MAIN = 'main',
  SIDEBAR = 'sidebar',
}
